<div class="loading" *ngIf="loading">Loading&#8230;</div>

